export class Consultations {
    static moduleName = 'consultations';
    static entityName = 'consultation';
    static listTitle = 'Справочник консультаций';
    static createTitle = 'Добавление новой консультации';
    static apiPrefix = '/consultations';
}